
import { MODULE } from "@/config/modules";
import { AuthService } from "@/services/auth-service";
import { DossierConfigService, IMollieProfile } from "@/services/dossier-config-service";
import AppSelectBank from "@/components/bank/SelectBankType.vue";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { ISelectItem } from "winfakt-vue-components/src/classes";
import AppMollieCreateProfile from "./MollieCreateProfile.vue";

export default FormLike.extend({
	data(){
		return {
			mollieSettings: DossierConfigService.getMollieConfig(),
			mollieProfiles: [] as IMollieProfile[],
			createProfileModal: false
		};
	},
	computed: {
		hasAccessToMollie():boolean{
			return AuthService.wfCompany.hasModule(this.mollieModuleID);
		},
		mollieModuleID():number{
			return MODULE.MOLLIE;
		},
		mollieProfileItems():ISelectItem<string>[]{
			return this.mollieProfiles.map(p=>{
				return {
					text: p.Name,
					value: p.ID
				};
			});
		}
	},
	methods: {
		async saveMollieSettings(){
			this.mollieSettings = await DossierConfigService.saveMollieConfig(this.mollieSettings);
			this.$wf.notify(this.$ct("saved"), "success", 3000, "check");
		},
		async connectWithMollie(){
			await DossierConfigService.connectWithMollie();
		},
		async disconnectFromMollie(){
			let confirmText = this.$ct("are-you-sure-you-want-to-disconnect-mollie");
			let confirm = await this.$wf.confirm(confirmText, this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "warning");
			if (!confirm) return;
			await DossierConfigService.mollieDisconnect();
			this.mollieSettings.ConnectedWithMollie = false;
		},
		async save(){
			this.mollieSettings = await DossierConfigService.saveMollieConfig(this.mollieSettings);
			this.$wf.notify(this.$ct("saved"), "success", 3000, "check");
		},
		onProfileCreated(profile:IMollieProfile){
			this.mollieProfiles.push(profile);
			this.createProfileModal = false;
		}
	},
	async created(){
		this.mollieSettings = DossierConfigService.getMollieConfig();
		if (this.mollieSettings.ConnectedWithMollie){
			this.mollieProfiles = await DossierConfigService.getMollieProfiles();
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	},
	components: {
		AppMissingModule,
		AppSelectBank,
		AppMollieCreateProfile
	}
});
